// Sign In
export const BLIINK_COPYRIGHT = '© BLIINK 2019';
export const SIGN_IN_FORM = 'SignInForm';
export const SIGN_FORM_EMAIL_LABEL = 'EMAIL';
export const SIGN_FORM_PASSWORD_LABEL = 'Mot de passe';
export const BACK_TO_SIGN_IN_LINK = 'Retour à la connexion';

// Create Password
export const CREATE_PASSWORD_FORM = 'CreatePasswordForm';
export const CREATE_PASSWORD_FORM_TITLE = 'Créez votre mot de passe';
export const CREATE_PASSWORD_FORM_PASSWORD_LABEL = 'Mot de passe';
export const CREATE_PASSWORD_FORM_CONFIRM_LABEL = 'Confirmez le mot de passe';

// Recovery password
export const RECOVERY_PASSWORD_FORM = 'RecoveryPasswordForm';
export const RECOVERY_PASSWORD_LINK = 'J\'ai oublié mon mot de passe';
export const RECOVERY_PASSWORD_EMAIL_LABEL = 'Email';

// Button
export const SUBMIT = 'Envoyer';
export const RECOVER = 'Envoyer';
export const ACCESS = 'Accéder';
export const CANCEL = 'Annuler';

// Error
export const MESSAGE_ERROR = 'Erreur';
export const MESSAGE_SUCCESS = 'Succès';
export const RESET_PASSWORD_SUCCESS = 'Votre mot de passe a bien été enregistré.';
export const RECOVER_PASSWORD_SUCCESS = 'Nous vous avons envoyé un email contenant un lien pour récupérer votre mot de passe.';

// Sign In
export const COOKIES_AUTHORIZATION_TOKEN = process.env.COOKIES_AUTHORIZATION_TOKEN || 'user_auth';
export const COOKIES_BLIINK_USERS = process.env.COOKIES_BLIINK_USERS || 'user';
export const EDIT_USER = 'Modifier mon profil';
export const LOGOUT_USER = 'Déconnexion';

// Profile
export const PROFILE_USER = 'Voir mon profil';
// Dashboard
export const DASHBOARD_PATH = 'Accéder au Dashboard';

// Date
export const DATE_FORMAT_FULL = 'DD MMM YYYY';

export const IS_ACTIVE = 'isActive';

// Colors
export const ALERT_COLORS = {
  red: '#AD0000',
  green: '#72C54B',
};

export const ALERT_DELAY = 6000

// Cookie
export const COOKIE_DOMAIN = (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging')
  ? '.bliink.io'
  : 'localhost';

// Routes
export const ROUTE_TITLE = {
  Applications: 'Applications',
  Users: 'Users',
  Organizations: 'Organizations',
  Profile: 'Profile',
  Dashboard: 'Home',
};

export const ROUTE_ICON = {
  dashboard: 'dashboard',
  user: 'user',
  applications: 'applications',
  organizations: 'organizations',
};

// Sorting
export const ASC = 'asc';
export const DESC = 'desc';

// NoData
export const NO_DATA = 'No data';

// LocalStorage
export const LOCALSTORAGE_PERSIST = 'persist:root';

// Modal
export const MODAL_TITLE_USER = 'Deleted this user ?';
export const MODAL_TITLE_ORGANIZATION = 'Delete this organization ?';
export const MODAL_DEFAULT_ORGANIZATION_NAME = 'this organization';
export const MODAL_DEFAULT_USER_NAME = 'this user';
export const MODAL_SURE_DELETE = 'Sure you want to delete'

// Organizations
export const BUTTON_CREATE_ORGANIZATION = 'New organization'
export const ORGANIZATION_EDITING = 'Editing organization <strong>{{name}}</strong>'
export const ORGANIZATION_CREATION = 'Creating a new organization'

// Users
export const USER_CREATE_BUTTON = 'New user'
export const USER_EDITING = 'Editing user<strong>{{name}}</strong>'
export const USER_CREATION = 'Creating a new user'

// Applications
export const BUTTON_CREATE_APPLICATION = 'New application';

// Forms
export const FORM_NAME_LABEL = 'Name'
export const FORM_SUBMIT_LABEL = SUBMIT
export const FORM_CANCEL_LABEL = CANCEL
export const FORM_ACCESS_RIGHTS = 'Access rights'

// Global
export const GLOBAL_YES = 'Yes';
export const GLOBAL_NO = 'No';
export const GLOBAL_USER = 'User'
export const GLOBAL_ORGANIZATION = 'Organization'
export const GLOBAL_ROLE = 'Role'
